import { render } from "./TvmVDVIcon.vue?vue&type=template&id=4a5d07cc"
import script from "./TvmVDVIcon.vue?vue&type=script&lang=js"
export * from "./TvmVDVIcon.vue?vue&type=script&lang=js"

import "./TvmVDVIcon.vue?vue&type=style&index=0&id=4a5d07cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/TvmVDVIcon/TvmVDVIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a5d07cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a5d07cc', __exports__)) {
    api.reload('4a5d07cc', __exports__)
  }
  
  module.hot.accept("./TvmVDVIcon.vue?vue&type=template&id=4a5d07cc", () => {
    api.rerender('4a5d07cc', render)
  })

}


export default __exports__